<template>
    <div id="event">
        <div class="stamp">
            <img src="@/assets/event/stamp/stamp.jpg" alt="" />
            <div class="button left" @click="onClickbutton('https://sourl.co/YGBrxy')"></div>
            <div class="button right" @click="onClickbutton('https://sourl.co/YcvfTF')"></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickbutton(url) {
            window.open(url, '_blank')
        },
        resizeHandler() {
            const buttons = document.querySelectorAll('#event .button')
            const width = document.querySelector('#event .stamp img').clientWidth
            for (const button of buttons) {
                button.style.width = (width / 375) * 92 + 'px'
                button.style.height = (width / 375) * 30 + 'px'
                button.style.top = (width / 375) * 760 + 'px'
                if (button.classList.contains('left')) {
                    button.style.left = (width / 375) * 65 + 'px'
                } else {
                    button.style.right = (width / 375) * 63 + 'px'
                }
            }
        }
    },
    mounted() {
        this.resizeHandler()
        window.addEventListener('resize', this.resizeHandler)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler)
    }
}
</script>
<style scoped>
#event {
    background-color: #FFF;
    display: flex;
    justify-content: center;
}
.stamp {
    position: relative;
    width: 100%;
    max-width: 750px;
}
.stamp img {
    width: 100%;
    height: 100%;
}
.stamp .button{
    position: absolute;
    cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/pages/event/stamp/Stamp.vue